export default __webpack_public_path__ + "compass.9c04c732449d454855a503d331ea0ba6.svg";